export const UNSHIPPED = "Unshipped";
export const SHIPPED = "Shipped";
export const CANCELLED = "Canceled";
export const RETURN = "Return";
export const CLONED = "Cloned";
export const NEW_PURCHASE_ORDER = "New";
export const PARTIAL_PURCHASE_ORDER = "Partial";
export const COMPLETED_PURCHASE_ORDER = "Completed";
export const ALL = "all"